import React from "react";

type Props = {
  width: number;
  height: number;
};

export const IconMailSVG: React.FC<Props> = ({ width, height }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 38.657 37.811"
    >
      <g
        id="グループ_583"
        data-name="グループ 583"
        transform="translate(-22 -324)"
      >
        <rect
          id="長方形_869"
          data-name="長方形 869"
          width="48"
          height="48"
          transform="translate(16 319)"
          fill="none"
        />
        <path
          id="envelope-light_1_"
          data-name="envelope-light (1)"
          d="M23.325,64H2.413A2.414,2.414,0,0,0,0,66.413V80.891A2.414,2.414,0,0,0,2.413,83.3H23.325a2.414,2.414,0,0,0,2.413-2.413V66.413A2.414,2.414,0,0,0,23.325,64ZM2.413,65.609H23.325a.807.807,0,0,1,.8.8v2.081c-1.1.93-2.674,2.212-7.571,6.1-.85.674-2.524,2.3-3.69,2.277-1.166.02-2.845-1.6-3.69-2.277-4.9-3.886-6.47-5.168-7.571-6.1V66.413A.807.807,0,0,1,2.413,65.609ZM23.325,81.695H2.413a.807.807,0,0,1-.8-.8V70.585c1.146.94,2.956,2.393,6.57,5.263,1.031.824,2.85,2.639,4.69,2.629,1.83.015,3.634-1.785,4.69-2.629,3.614-2.87,5.424-4.323,6.57-5.263V80.891A.807.807,0,0,1,23.325,81.695Z"
          transform="translate(26.856 269.392)"
          fill="#fff"
        />
      </g>
    </svg>
  );
};
